import Boolean from 'Lib/components/common/Boolean';
import Currency from 'Lib/components/common/Currency';
import Date from 'Lib/components/common/Date';
import Paragraph from 'Lib/components/common/Paragraph';
import Text from 'Lib/components/common/Text';
import FieldTypes from 'Lib/constants/settings/fieldTypes';
import CurrencyField from 'Lib/muiComponents/form/CurrencyField';
import DatePickerField from 'Lib/muiComponents/form/DatePickerField';
import NumberField from 'Lib/muiComponents/form/NumberField';
import RadioField from 'Lib/muiComponents/form/RadioField';
import SelectField from 'Lib/muiComponents/form/SelectField';
import TextAreaField from 'Lib/muiComponents/form/TextAreaField';
import TextField from 'Lib/muiComponents/form/TextField';
import isEmpty from 'Lib/utilities/isEmpty';
import isJSON from 'Lib/utilities/isJSON';

const getDropdownOptions = values => {
	if (!values) return [];

	try {
		const parsed = typeof values === 'string' ? JSON.parse(values) : values;

		const optionsArray = Array.isArray(parsed?.options)
			? parsed.options
			: typeof parsed?.options === 'string'
				? JSON.parse(parsed.options)
				: parsed?.options
					? [parsed.options]
					: [];

		return optionsArray
			.filter(option => option != null && option !== '')
			.map(option => ({ label: option, value: option }));
	} catch {
		return typeof values === 'string'
			? values
					.split('\n')
					.filter(option => option.trim() !== '')
					.map(option => ({ label: option, value: option }))
			: [];
	}
};

export const getComponentByFieldTypeID = (
	{
		customFieldID,
		templateFieldID,
		fieldTypeID,
		value,
		name,
		settings,
		options
	},
	editing
) => {
	switch (parseInt(fieldTypeID)) {
		case FieldTypes.SingleLineText:
			if (editing) {
				return (
					<TextField
						name={customFieldID || templateFieldID}
						label={name}
						margin="normal"
					/>
				);
			} else {
				return <Text value={value} />;
			}
		case FieldTypes.Paragraph:
			if (editing) {
				return (
					<TextAreaField
						name={customFieldID || templateFieldID}
						label={name}
						margin="normal"
					/>
				);
			} else {
				return <Paragraph value={value} emptyText="--" />;
			}
		case FieldTypes.Dropdown:
			if (editing) {
				let selectOptions = [];

				if (!settings && !isEmpty(options)) {
					selectOptions = options.map(option => {
						return {
							label: option,
							value: option
						};
					});
				}

				return (
					<SelectField
						name={customFieldID || templateFieldID}
						label={name}
						margin="normal"
						options={
							settings
								? getDropdownOptions(settings)
								: selectOptions
						}
					/>
				);
			} else {
				return <Text value={value} />;
			}
		case FieldTypes.Toggle:
			if (editing) {
				return (
					<RadioField
						name={customFieldID || templateFieldID}
						label={name}
						value={null}
						options={[
							{ label: 'N/A', value: null },
							{ label: 'No', value: '0' },
							{ label: 'Yes', value: '1' }
						]}
					/>
				);
			} else {
				return <Boolean value={value} />;
			}
		case FieldTypes.Date:
			if (editing) {
				return (
					<DatePickerField
						required={false}
						name={customFieldID || templateFieldID}
						margin="normal"
						label={name}
					/>
				);
			} else {
				return <Date value={value} />;
			}
		case FieldTypes.Numeric:
			if (editing) {
				return (
					<NumberField
						name={customFieldID || templateFieldID}
						margin="normal"
						label={name}
					/>
				);
			} else {
				return <Text value={value} />;
			}
		case FieldTypes.Currency:
			if (editing) {
				return (
					<CurrencyField
						name={customFieldID || templateFieldID}
						margin="normal"
						label={name}
					/>
				);
			} else {
				return <Currency value={value} />;
			}
		case FieldTypes.WholeNumber:
			if (editing) {
				return (
					<NumberField
						name={customFieldID || templateFieldID}
						margin="normal"
						label={name}
					/>
				);
			} else {
				return <Text value={value} />;
			}
		default:
			break;
	}
};

export default getComponentByFieldTypeID;
